import React from 'react';

import Aux from '../../hoc/Aux';
import Navigation from './Navigation';

const participations = (props) => {

  return (
    <Aux>
    	<div className="main-container">
    		<div className="container">
    			<div className="row justify-content-center mt-5">
    				<div className="col-lg-10 col-xl-9">
    					<div className="page-header">
    						<h1 className="pb-2">Mein Account</h1>
    						<p className="lead">Bitte füllen Sie sämtliche Felder des nachstehenden Formulars aus. Nach dem Absenden erhalten Sie eine E-Mail mit der Bestätigung sowie einem Link zum Abschluss der Anmeldung mit Passwortvergabe.</p>
    					</div>
    				</div>
    			</div>
    			<div className="row justify-content-center mt-3">
    				<div className="col-lg-3 mb-3">
    					<Navigation activeItem="participations" />
    				</div>
    				<div className="col-lg-7 col-xl-6">
    					<div className="card">
    						<div className="card-body">
    							<div className="tab-content">
    								<div className="tab-pane fade show active" role="tabpanel" id="userdata">
    									<h4>Projektbeteiligungen</h4>
                      kommt noch
    								</div>
    							</div>
    						</div>
    					</div>
    				</div>
    			</div>
    		</div>
    	</div>
    </Aux>
  );


};

export default participations;



// WEBPACK FOOTER //
// ./src/components/User/Participations.js